module.exports = __webpack_public_path__ + "img/soeren.1e4732fa.jpg";